<div class="flex align-items-center" [style.width]="width ? width : '100%'" #container>
  <div class="w-full">
    <span [ngClass]="{ 'p-float-label': showFloatLabel }">
      <p-autoComplete
        #dropdown
        [jmlAutoSelect]="autoSelect"
        [elementId]="'autocomplete_' + field"
        [formControl]="control"
        [autoHighlight]="true"
        [forceSelection]="true"
        [inputId]="'autocomplete_' + field"
        [style]="{ width: '100%' }"
        (onFocus)="handleFocus()"
        (onBlur)="handleBlur()"
        (onSelect)="onSelect($event)"
        [dropdown]="true"
        [suggestions]="filteredOptions"
        (completeMethod)="getFilteredOptions($event)"
        field="name"
        [appendTo]="appendTo"
        delay="10"
      >
        <ng-template let-entry pTemplate="item">
          <div class="flex align-items-center gap-2">
            <i *ngIf="!!entry?.icon && !hideIcon" [class]="entry?.icon" [style.color]="entry?.color"></i>
            <!-- always render div, conditionally render tooltip   -->
            <div
              class="flex align-items-center gap-2"
              [pTooltip]="!!hideTooltip || !entry?.desc ? null : entry?.desc"
              tooltipPosition="top"
            >
              <div *ngIf="!hideLabel">{{ entry.name }}</div>
              <div *ngIf="!!entry?.abbr && !hideLabel && !hideAbbr" class="label-small-grey">({{ entry.abbr }})</div>
            </div>
          </div>
        </ng-template>
      </p-autoComplete>
      <label *ngIf="!!placeholder && showFloatLabel" [for]="'autocomplete_' + field">{{ placeholder }}</label>
    </span>
  </div>
  <button
    *ngIf="showDelete"
    pButton
    type="button"
    tabindex="-1"
    class="ml-1"
    (click)="onClickDelete()"
    icon="pi pi-times"
  ></button>
  <ng-content></ng-content>
</div>
